(() => {
  const syncPrice = form => {
    const choice = form.querySelector('[data-replica-choice]:checked');
    if (!choice) return;
    document.querySelectorAll('[data-replica-total-for]').forEach(total => {
      if (total.dataset.replicaTotalFor === form.getAttribute('id')) total.textContent = choice.dataset.displayPrice;
    });
  };
  const init = (scope = document) => {
    scope.querySelectorAll('[data-replica-form]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.querySelectorAll('[data-replica-bundle]').forEach(option => { option.hidden = false; });
      form.addEventListener('change', event => {
        if (event.target.matches('[data-replica-choice]')) syncPrice(form);
      });
      syncPrice(form);
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (form.dataset.busy) return;
        const error = form.querySelector('[data-replica-error]');
        const buttons = [...document.querySelectorAll('button[type="submit"]')].filter(button => button.form === form);
        form.dataset.busy = 'true';
        buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
        error.hidden = true;
        const gift = form.querySelector('[data-included-gift]');
        const items = [{ id: Number(form.elements.id.value), quantity: 1,
          ...(gift ? { properties: { 'Included free gift': gift.value } } : {}) }];
        const addon = form.querySelector('[data-replica-addon]:checked');
        if (addon) items.push({ id: Number(addon.value), quantity: 1 });
        try {
          if (window.haloMarketReady && !await window.haloMarketReady) throw new Error('Market could not be confirmed');
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart add failed');
          window.location.assign(form.elements.return_to.value);
        } catch {
          delete form.dataset.busy;
          buttons.forEach(button => { button.disabled = false; button.removeAttribute('aria-busy'); });
          error.hidden = false;
          error.focus();
        }
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  window.addEventListener('pageshow', () => document.querySelectorAll('[data-replica-form]').forEach(form => {
    syncPrice(form);
    if (!form.dataset.busy) return;
    delete form.dataset.busy;
    document.querySelectorAll('button[aria-busy="true"]').forEach(button => {
      if (button.form === form) { button.disabled = false; button.removeAttribute('aria-busy'); }
    });
  }));
})();
